<template>
  <div class="churn-description-popup">
    <churn-popup :buttons="buttonOptions" :close-action="close">
      <template v-slot:popup-content>
        <churn-description-popup-content/>
      </template>
    </churn-popup>
  </div>
</template>

<script>
import ChurnPopup from './ChurnPopup.vue';
import ChurnDescriptionPopupContent from './ChurnDescriptionPopupContent.vue';
import ChurnValidateActionPopup from './ChurnValidateActionPopup.vue';
import ModalBus from '../../../../event-bus/modal-bus';
import Segment from '../../../../Segment';
import Intercom from '../../../../Intercom';

export default {
  name: 'ChurnDescriptionPopup',
  components: {
    ChurnPopup,
    ChurnDescriptionPopupContent,
  },
  created() {
    Segment.trackUserInteraction('ChurnDescriptionPopup_Shown');
  },
  computed: {
    buttonOptions() {
      return [{
        title: 'אני רוצה לדבר עם הצוות',
        action: () => this.chatWithCx(),
        variant: 'warning',
      }, {
        title: 'אני רוצה להמשיך במחיקה',
        action: () => this.approve(),
        variant: 'danger',
      }, {
        title: 'אני לא רוצה להמשיך',
        action: () => this.discard(),
        variant: 'secondary-black',
      }];
    },
  },
  methods: {
    close() {
      Segment.trackUserInteraction('ChurnDescriptionPopup_CloseClicked');
      this.$emit('close');
    },
    approve() {
      Segment.trackUserInteraction('ChurnDescriptionPopup_ApproveClicked');
      ModalBus.$emit('open', {
        component: ChurnValidateActionPopup,
        props: {},
      });
    },
    discard() {
      Segment.trackUserInteraction('ChurnDescriptionPopup_DiscardClicked');
      this.$emit('close');
    },
    chatWithCx() {
      Segment.trackUserInteraction('ChurnDescriptionPopup_ChatWithCxClicked');
      this.$emit('close');
      Intercom.showNewMessage(`הי,
חשבתי לעזוב את השירות. לפני שאני עושה את זה, רציתי לדבר אתכם על:
`);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/churn/ChurnDescriptionPopup.vue